import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=328ab6f3&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ab6f3",
  null
  
)

export default component.exports